import React from "react";
import HighlightIcon from '@mui/icons-material/Highlight';

function Header(){
    return <React.StrictMode>
    <header>
        <h1><HighlightIcon/>Keeper</h1>
    </header>
  </React.StrictMode>
}
export default Header;
